import { useEffect, useMemo, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { KeyButton } from '~/components/ui/KeyButton';
import { IButtonActionState, rage, useObservable } from '~/rage';
import { StyledContainer, StyledWrapper } from './ActionButton.styled';

const ActionButton = () => {
	const action = useObservable(rage.buttonActions.getDisplayedAction());
	const playerIsTalking = useObservable(rage.player.getPlayerIsTalking());
	const notification = useObservable(
		rage.notifications.getDisplayedNotification(),
	);
	const notifications = useObservable(
		rage.notifications.getDisplayedNotifications(),
	);
	const [visibleAction, setVisibleAction] = useState<IButtonActionState | null>(
		null,
	);

	const notificationCount = useMemo(() => {
		if (notification?.duration !== undefined) {
			return 1;
		}

		return Math.min(3, notifications.length);
	}, [notification, notifications]);

	const bottom = useMemo(() => {
		const notificationLiftByCount = [0, 60, 110, 160];
		if (playerIsTalking) {
			return 110 + notificationLiftByCount[notificationCount];
		}

		return 40 + notificationLiftByCount[notificationCount];
	}, [playerIsTalking, notificationCount]);

	useEffect(() => {
		if (!action) return;

		setVisibleAction(action);
	}, [action]);

	return (
		<CSSTransition
			in={!!action}
			classNames={'action-button'}
			timeout={300}
			unmountOnExit
		>
			<StyledWrapper style={{ bottom: bottom }}>
				<StyledContainer>
					<KeyButton keyName={visibleAction?.button || ''} />
					<p>{visibleAction?.text}</p>
				</StyledContainer>
			</StyledWrapper>
		</CSSTransition>
	);
};

export { ActionButton };
